import type { Party } from '@/features/party/types';

export default function isPartyInCrm(party: Maybe<Party>, crmKey: string) {
  if (!party) return false;

  return party.external_refs.some(
    (ref) => ref.company.toLowerCase() === crmKey.toLowerCase(),
  );
}
